// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatar__Avatar-HmSvc"};